import { getBuyerToken } from '../index.ts';
import { type Cookie } from './types.ts';
import { getCookieValue } from 'dibs-consented-storage';
import { USER_EMAIL_TOKEN } from './constants.ts';

export function getEmailTokenString(cookie: Cookie): string {
    return getCookieValue(cookie, USER_EMAIL_TOKEN) || '';
}

type IsEmailOnlyUserTokenArg = {
    userToken?: string | null;
    emailToken?: string | null;
};
//Info about token prefixes: https://github.com/1stdibs/necrodibsicon/blob/master/back-end/identity-service/tokens/Token_Updates.md
//Currently supporting old emailToken
export const isEmailOnlyUserToken = ({
    userToken,
    emailToken,
}: IsEmailOnlyUserTokenArg = {}): boolean => {
    const emailOnlyTokenPrefixPattern = /\d+\_+m-/;
    return (
        (userToken && !!userToken.match(emailOnlyTokenPrefixPattern)) ||
        (!!emailToken && !userToken)
    );
};

export const isEmailOnly = (cookie: Cookie): boolean => {
    const tokenObj = getBuyerToken(cookie);
    return isEmailOnlyUserToken(tokenObj);
};
